import { render, staticRenderFns } from "./CajasActivas.vue?vue&type=template&id=652530b2&"
import script from "./CajasActivas.vue?vue&type=script&lang=js&"
export * from "./CajasActivas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports